<template>
    <div>
        <div v-if="this.$store.state.activeProfile.role == 'driver'|| this.$store.state.activeProfile.role == 'hybrid-driver'">
            <v-toolbar class="main">
                <button class="nav-back" @click="goBack">&lt; Välj kund</button>
            </v-toolbar>
        </div>
        <div v-else-if="(this.$store.state.activeProfile.role == 'warehouse' || this.$store.state.activeProfile.role == 'hybrid-warehouse') && !this.$store.state.isDistributor">
            <v-toolbar class="main">
                <button v-if="!this.$store.state.currentDelivery.completed" class="nav-back" @click="goBackWarehouse">&lt; Leveranser</button>
                <button v-if="this.$store.state.currentDelivery.completed" class="nav-back" @click="backToHome">&lt; Leveranser</button>
            </v-toolbar>
        </div>

        <v-container grid-list-md summary>
            <div v-if="this.$store.state.activeProfile.role == 'driver' || this.$store.state.activeProfile.role == 'hybrid-driver'">
                <v-card class="reciept">
                    <h2 class="mt-4 mb-3">Summering</h2>
                    <v-layout row wrap mb-3>
                        <v-flex xs6>
                            <ul class="summary mb-3">
                                <li><h3 class="mb-1">Incheckat</h3></li>
                                <li :class="{ mute:pallet_quantity_in_isEmpty }"><input v-model="pallet_quantity_in" readonly> Helpall</li>
                                <li :class="{ mute:pallet_half_quantity_in_isEmpty }"><input v-model="pallet_half_quantity_in" readonly> Halvpall</li>
                                <li :class="{ mute:rolling_pallet_quantity_in_isEmpty }"><input v-model="rolling_pallet_quantity_in" readonly> Rullcontainer</li>
                                <!--<li><input v-model="veg_crate_quantity_in" readonly> Back</li>-->
                                <li :class="{ mute:plastpall_quantity_in_isEmpty }"><input v-model="plastpall_quantity_in" readonly> Plastpall</li>
                                <li :class="{ mute:plastpall_half_quantity_in_isEmpty }"><input v-model="plastpall_half_quantity_in" readonly> Plastpall Halv</li>
                                <li :class="{ mute:lokbin_quantity_in_isEmpty }"><input v-model="lokbin_quantity_in" readonly> Lökbin</li>
                                <li :class="{ mute:kyl_quantity_in_isEmpty }"><input v-model="kyl_quantity_in" readonly> Kyl</li>
                                <li :class="{ mute:giant_cage_quantity_in_isEmpty }"><input v-model="giant_cage_quantity_in" readonly> Jätten bur</li>
                                <li :class="{ mute:disposable_pallet_quantity_in_isEmpty }"><input v-model="disposable_pallet_quantity_in" readonly> Engångspall</li>
                            </ul>
                        </v-flex>
                        <v-flex xs6>
                            <ul class="summary mb-3">
                                <li><h3 class="mb-1">Utcheckat</h3></li>
                                <li :class="{ mute:pallet_quantity_out_isEmpty }"><input v-model="pallet_quantity_out" readonly> Helpall</li>
                                <li :class="{ mute:pallet_half_quantity_out_isEmpty }"><input v-model="pallet_half_quantity_out" readonly> Halvpall</li>
                                <li :class="{ mute:rolling_pallet_quantity_out_isEmpty }"><input v-model="rolling_pallet_quantity_out" readonly> Rullcontainer</li>
                                <li :class="{ mute:veg_crate_quantity_out_isEmpty }"><input v-model="veg_crate_quantity_out" readonly> Back</li>
                                <li :class="{ mute:plastpall_quantity_out_isEmpty }"><input v-model="plastpall_quantity_out" readonly> Plastpall</li>
                                <li :class="{ mute:plastpall_half_quantity_out_isEmpty }"><input v-model="plastpall_half_quantity_out" readonly> Plastpall Halv</li>
                                <li :class="{ mute:lokbin_quantity_out_isEmpty }"><input v-model="lokbin_quantity_out" readonly> Lökbin</li>
                                <li :class="{ mute:kyl_quantity_out_isEmpty }"><input v-model="kyl_quantity_out" readonly> Kyl</li>
                                <li :class="{ mute:giant_cage_quantity_out_isEmpty }"><input v-model="giant_cage_quantity_out" readonly> Jätten bur</li>
                                <li :class="{ mute:disposable_pallet_quantity_out_isEmpty }"><input v-model="disposable_pallet_quantity_out" readonly> Engångspall</li>
                            </ul>

                        </v-flex>
                    </v-layout>
                </v-card>
                <div>
                    <v-btn color="primary" block @click.native="submit">Spara</v-btn>
                </div>
            </div>
            <div v-else-if="(this.$store.state.activeProfile.role == 'warehouse' || this.$store.state.activeProfile.role == 'hybrid-warehouse') && !this.$store.state.isDistributor">
                <v-card class="reciept">
                    <h2 class="mt-4 mb-3">Summering</h2>
                    <v-layout row wrap mb-3>
                        <v-flex xs6>
                            <ul class="summary mb-3">
                                <li><h3 class="mb-1">Incheckat</h3></li>
                                <li :class="{ mute:pallet_quantity_returned_isEmpty }"><input v-model="pallet_quantity_returned" readonly> Helpall</li>
                                <li :class="{ mute:pallet_half_quantity_returned_isEmpty }"><input v-model="pallet_half_quantity_returned" readonly> Halvpall</li>
                                <li :class="{ mute:rolling_pallet_quantity_returned_isEmpty }"><input v-model="rolling_pallet_quantity_returned" readonly> Rullcontainer</li>
                                <li :class="{ mute:veg_crate_quantity_returned_isEmpty }"><input v-model="veg_crate_quantity_returned" readonly> Back</li>
                                <li :class="{ mute:plastpall_quantity_returned_isEmpty }"><input v-model="plastpall_quantity_returned" readonly> Plastpall</li>
                                <li :class="{ mute:plastpall_half_quantity_returned_isEmpty }"><input v-model="plastpall_half_quantity_returned" readonly> Plastpall Halv</li>
                                <li :class="{ mute:lokbin_quantity_returned_isEmpty }"><input v-model="lokbin_quantity_returned" readonly> Lökbin</li>
                                <li :class="{ mute:kyl_quantity_returned_isEmpty }"><input v-model="kyl_quantity_returned" readonly> Kyl</li>
                                <li :class="{ mute:giant_cage_quantity_returned_isEmpty }"><input v-model="giant_cage_quantity_returned" readonly> Jätten bur</li>
                                <li :class="{ mute:disposable_pallet_quantity_returned_isEmpty }"><input v-model="disposable_pallet_quantity_returned" readonly> Engångspall</li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-card>
                <div>
                    <v-btn v-if="!this.$store.state.currentDelivery.completed" color="primary" block @click.native="submit">Spara</v-btn>
                    <v-btn v-if="this.$store.state.currentDelivery.completed" color="primary" block @click.native="backToHome">Back to Home</v-btn>
                </div>
            </div>
            <div v-if="this.$store.state.isDistributor">
                <v-card class="reciept">
                    <h2 class="mt-4 mb-3">Summering</h2>
                    <v-layout row wrap mb-3>
                        <v-flex xs6>
                            <ul class="summary mb-3">
                                <li><h3 class="mb-1">Incheckat</h3></li>
                                <li :class="{ mute:pallet_quantity_isEmpty }"><input v-model="pallet_quantity" readonly> Helpall</li>
                                <li :class="{ mute:pallet_half_quantity_isEmpty }"><input v-model="pallet_half_quantity" readonly> Halvpall</li>
                                <li :class="{ mute:rolling_pallet_quantity_isEmpty }"><input v-model="rolling_pallet_quantity" readonly> Rullcontainer</li>
                                <li :class="{ mute:veg_crate_quantity_isEmpty }"><input v-model="veg_crate_quantity" readonly> Back</li>
                                <li :class="{ mute:plastpall_quantity_isEmpty }"><input v-model="plastpall_quantity" readonly> Plastpall</li>
                                <li :class="{ mute:plastpall_half_quantity_isEmpty }"><input v-model="plastpall_half_quantity" readonly> Plastpall Halv</li>
                                <li :class="{ mute:lokbin_quantity_isEmpty }"><input v-model="lokbin_quantity" readonly> Lökbin</li>
                                <li :class="{ mute:kyl_quantity_isEmpty }"><input v-model="kyl_quantity" readonly> Kyl</li>
                                <li :class="{ mute:giant_cage_quantity_isEmpty }"><input v-model="giant_cage_quantity" readonly> Jätten bur</li>
                                <li :class="{ mute:disposable_pallet_quantity_isEmpty }"><input v-model="disposable_pallet_quantity" readonly> Engångspall</li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-card>
                <div>
                    <v-btn color="primary" block @click.native="submit">Spara</v-btn>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { uuid } from 'vue-uuid'

export default {
    data: function data() {
      return {
        lat: 0,
        lng: 0,
        rolling_pallet_quantity_in_isEmpty: {},
        pallet_quantity_in_isEmpty: {},
        pallet_quantity_returned_isEmpty: {},
        pallet_half_quantity_returned_isEmpty: {},
        rolling_pallet_quantity_returned_isEmpty: {},
        veg_crate_quantity_returned_isEmpty: {},
        plastpall_quantity_returned_isEmpty: {},
        plastpall_half_quantity_returned_isEmpty: {},
        lokbin_quantity_returned_isEmpty: {},
        kyl_quantity_returned_isEmpty: {},
        giant_cage_quantity_returned_isEmpty: {},
        disposable_pallet_quantity_returned_isEmpty: {},
        pallet_half_quantity_in_isEmpty: {},
        plastpall_quantity_in_isEmpty: {},
        plastpall_half_quantity_in_isEmpty: {},
        lokbin_quantity_in_isEmpty: {},
        kyl_quantity_in_isEmpty: {},
        giant_cage_quantity_in_isEmpty: {},
        disposable_pallet_quantity_in_isEmpty: {},
        pallet_quantity_out_isEmpty: {},
        pallet_half_quantity_out_isEmpty: {},
        rolling_pallet_quantity_out_isEmpty: {},
        veg_crate_quantity_out_isEmpty: {},
        plastpall_quantity_out_isEmpty: {},
        plastpall_half_quantity_out_isEmpty: {},
        lokbin_quantity_out_isEmpty: {},
        kyl_quantity_out_isEmpty: {},
        giant_cage_quantity_out_isEmpty: {},
        disposable_pallet_quantity_out_isEmpty: {},
        pallet_half_quantity_isEmpty: {},
        pallet_quantity_isEmpty: {},
        rolling_pallet_quantity_isEmpty: {},
        veg_crate_quantity_isEmpty: {},
        plastpall_quantity_isEmpty: {},
        plastpall_half_quantity_isEmpty: {},
        lokbin_quantity_isEmpty: {},
        kyl_quantity_isEmpty: {},
        giant_cage_quantity_isEmpty: {},
        disposable_pallet_quantity_isEmpty: {}
      }
    },
    methods:{
        goBackWarehouse(){
            this.$router.push('Delivery_Details');
        },
        goBack(){
            this.$router.push('CheckInOut');
        },
        backToHome(){
            this.$router.push('warehouse_Home');
        },
        submit(){

            if (this.$store.state.activeProfile.role == 'driver' || this.$store.state.activeProfile.role == 'hybrid-driver') {

                // Set lat/long of transaction, or if undefined set to null
                if (this.$store.state.deviceLocation.position.coords === undefined) {
                    this.$store.state.transaction.latitude    = this.$store.state.transaction.longitude = 0;
                } else {
                    this.$store.state.transaction.latitude    = this.$store.state.deviceLocation.position.coords.latitude;
                    this.$store.state.transaction.longitude   = this.$store.state.deviceLocation.position.coords.longitude;
                }

                this.$store.state.transaction.key         = this.$uuid.v4();
                this.$store.state.transaction.customer_id = this.$store.state.activeCustomer.custID;

                this.$store.state.transaction.staff_id                       = this.$store.state.activeProfile.staff_id;
                this.$store.state.transaction.created_at                     = Date.now();
                this.$store.state.transaction.pallet.quantity_in             = this.$store.state.activeCustomer.pallet.quantity_in;
                this.$store.state.transaction.pallet.quantity_out            = this.$store.state.activeCustomer.pallet.quantity_out;
                this.$store.state.transaction.pallet_half.quantity_in        = this.$store.state.activeCustomer.pallet_half.quantity_in;
                this.$store.state.transaction.pallet_half.quantity_out       = this.$store.state.activeCustomer.pallet_half.quantity_out;
                this.$store.state.transaction.rolling_pallet.quantity_in     = this.$store.state.activeCustomer.rolling_pallet.quantity_in;
                this.$store.state.transaction.rolling_pallet.quantity_out    = this.$store.state.activeCustomer.rolling_pallet.quantity_out;
                this.$store.state.transaction.veg_crate.quantity_in          = this.$store.state.activeCustomer.veg_crate.quantity_in;
                this.$store.state.transaction.veg_crate.quantity_out         = this.$store.state.activeCustomer.veg_crate.quantity_out;
                this.$store.state.transaction.plastpall.quantity_out         = this.$store.state.activeCustomer.plastpall.quantity_out;
                this.$store.state.transaction.plastpall.quantity_in          = this.$store.state.activeCustomer.plastpall.quantity_in;
                this.$store.state.transaction.plastpall_half.quantity_out    = this.$store.state.activeCustomer.plastpall_half.quantity_out;
                this.$store.state.transaction.plastpall_half.quantity_in     = this.$store.state.activeCustomer.plastpall_half.quantity_in;
                this.$store.state.transaction.lokbin.quantity_out            = this.$store.state.activeCustomer.lokbin.quantity_out;
                this.$store.state.transaction.lokbin.quantity_in             = this.$store.state.activeCustomer.lokbin.quantity_in;
                this.$store.state.transaction.kyl.quantity_out               = this.$store.state.activeCustomer.kyl.quantity_out;
                this.$store.state.transaction.kyl.quantity_in                = this.$store.state.activeCustomer.kyl.quantity_in;
                this.$store.state.transaction.giant_cage.quantity_out        = this.$store.state.activeCustomer.giant_cage.quantity_out;
                this.$store.state.transaction.giant_cage.quantity_in         = this.$store.state.activeCustomer.giant_cage.quantity_in;
                this.$store.state.transaction.disposable_pallet.quantity_out = this.$store.state.activeCustomer.disposable_pallet.quantity_out;
                this.$store.state.transaction.disposable_pallet.quantity_in  = this.$store.state.activeCustomer.disposable_pallet.quantity_in;

                console.log("this.$store.state.transaction.staff_id: ", this.$store.state.transaction.staff_id);

                this.$store.commit('commitSingleTransaction');
                this.$router.push('Driver_Home');

            }else if ((this.$store.state.activeProfile.role == 'warehouse' || this.$store.state.activeProfile.role == 'hybrid-warehouse') && !this.$store.state.isDistributor) {
                console.log("At warehouse Review");

                if(!this.$store.state.isReview){
                    // set up the transaction object to send to the backend
                    this.$store.state.deliveryTransaction.type               = "customer";
                    this.$store.state.deliveryTransaction.tour_id            = this.$store.state.currentDelivery.tour_id;
                    this.$store.state.deliveryTransaction.approving_staff_id = this.$store.state.activeProfile.staff_id;
                    this.$store.state.deliveryTransaction.key                = this.$uuid.v4();
                    this.$store.state.deliveryTransaction.created_at         = Date.now();
                    this.$store.state.deliveryTransaction.pallets            = this.$store.state.currentDelivery.expected_pallets;

                    this.$store.state.lastTourID = this.$store.state.currentDelivery.tour_id;

                    this.$store.commit('returnedPalletsAssessment');
                }

                this.$router.push('Warehouse_Home');
            }else if((this.$store.state.activeProfile.role == 'warehouse' || this.$store.state.activeProfile.role == 'hybrid-warehouse') && this.$store.state.isDistributor){

                // set up the transaction object to send to the backend
                if (this.$store.state.deviceLocation.position.coords === undefined) {
                    this.$store.state.distributorTransaction.latitude = this.$store.state.distributorTransaction.longitude = 0;
                } else {
                    this.$store.state.distributorTransaction.latitude           = this.$store.state.deviceLocation.position.coords.latitude;
                    this.$store.state.distributorTransaction.longitude          = this.$store.state.deviceLocation.position.coords.longitude;
                }

                this.$store.state.distributorTransaction.type               = "distributor";
                this.$store.state.distributorTransaction.key                = this.$uuid.v4();
                this.$store.state.distributorTransaction.created_at         = Date.now();
                this.$store.state.distributorTransaction.supplier_id        = this.$store.state.currentDistributor.supplier_id;
                this.$store.state.distributorTransaction.staff_id           = this.$store.state.activeProfile.staff_id;

                this.$store.state.distributorTransaction.pallet.quantity_in             = this.$store.state.currentDistributorPallets.pallets.pallet.quantity_in;
                this.$store.state.distributorTransaction.pallet_half.quantity_in        = this.$store.state.currentDistributorPallets.pallets.pallet_half.quantity_in;
                this.$store.state.distributorTransaction.rolling_pallet.quantity_in     = this.$store.state.currentDistributorPallets.pallets.rolling_pallet.quantity_in;
                this.$store.state.distributorTransaction.veg_crate.quantity_in          = this.$store.state.currentDistributorPallets.pallets.veg_crate.quantity_in;
                this.$store.state.distributorTransaction.plastpall.quantity_in          = this.$store.state.currentDistributorPallets.pallets.plastpall.quantity_in;
                this.$store.state.distributorTransaction.plastpall_half.quantity_in     = this.$store.state.currentDistributorPallets.pallets.plastpall_half.quantity_in;
                this.$store.state.distributorTransaction.lokbin.quantity_in             = this.$store.state.currentDistributorPallets.pallets.lokbin.quantity_in;
                this.$store.state.distributorTransaction.kyl.quantity_in                = this.$store.state.currentDistributorPallets.pallets.kyl.quantity_in;
                this.$store.state.distributorTransaction.giant_cage.quantity_in         = this.$store.state.currentDistributorPallets.pallets.giant_cage.quantity_in;
                this.$store.state.distributorTransaction.disposable_pallet.quantity_in  = this.$store.state.currentDistributorPallets.pallets.disposable_pallet.quantity_in;
                //this.$store.state.distributorTransaction.pallets            = this.$store.state.currentDistributorPallets.pallets;

                this.$store.commit('commitDistributorTransaction');
                this.$router.push('Warehouse_Home');
            }
        }
      },
      created: function(){
          // make sure the snackbar is set to false so it can be triggered again by the next screen
            this.$store.state.snackbarTrigger = false;

            if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
                window.alert("Fel: Vänligen logga in");
                this.$router.push('/');
            }

          if (this.$store.state.activeProfile.role == "driver" || this.$store.state.activeProfile.role == "hybrid-driver") {
              if (this.$store.state.transaction.signed == null) {
                  window.alert("Fel: Transaktionen avbruten");
                  this.$router.push('/Driver_Home');
              }

              if(this.$store.state.activeCustomer === null || this.$store.state.activeCustomer.name === "" || this.$store.state.activeCustomer === {} || this.$store.state.activeCustomer.address == ""){
                  window.alert("Fel: Vänligen välj kund");
                  this.$router.push('/Driver_Home');
              }
          }

          if (this.$store.state.activeProfile.role == "warehouse" || this.$store.state.activeProfile.role == "hybrid-warehouse") {
              if (this.$store.state.isDistributor) {
                  // Validation for distributor(supplier) transaction
                  if (this.$store.state.distributorTransaction.signed == null || this.$store.state.distributorTransaction.signed == "") {
                      console.log("Transaction Error: Transaction Aborted");
                      this.$router.push('/Warehouse_Home');
                  }

              } else {
                  // Validation for Standard deliveries
                  if (this.$store.state.currentDelivery.tour_id == null || this.$store.state.currentDelivery.tour_id == "") {
                      console.log("Transaction Error: Transaction Aborted");
                      this.$router.push('/Warehouse_Home');
                  }

              }
          }


      },
      computed: {
          rolling_pallet_quantity_in: {
              get(){
                  if (this.$store.state.activeCustomer.rolling_pallet.quantity_in == 0) {
                      this.rolling_pallet_quantity_in_isEmpty = true;
                  } else {
                      this.rolling_pallet_quantity_in_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.rolling_pallet.quantity_in;
              },
              set (){}
          },
          pallet_quantity_in: {
              get(){
                  if (this.$store.state.activeCustomer.pallet.quantity_in == 0) {
                      this.pallet_quantity_in_isEmpty = true;
                  } else {
                      this.pallet_quantity_in_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.pallet.quantity_in;
              },
              set (){}
          },
          pallet_half_quantity_in: {
              get(){
                  if (this.$store.state.activeCustomer.pallet_half.quantity_in == 0) {
                      this.pallet_half_quantity_in_isEmpty = true;
                  } else {
                      this.pallet_half_quantity_in_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.pallet_half.quantity_in;
              },
              set (){}
          },
          plastpall_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.plastpall.quantity_in == 0) {
                    this.plastpall_quantity_in_isEmpty = true;
                } else {
                    this.plastpall_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.plastpall.quantity_in;
            },
            set (){}
          },
          plastpall_half_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.plastpall_half.quantity_in == 0) {
                    this.plastpall_half_quantity_in_isEmpty = true;
                } else {
                    this.plastpall_half_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.plastpall_half.quantity_in;
            },
            set (){}
          },
          lokbin_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.lokbin.quantity_in == 0) {
                    this.lokbin_quantity_in_isEmpty = true;
                } else {
                    this.lokbin_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.lokbin.quantity_in;
            },
            set (){}
          },
          kyl_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.kyl.quantity_in == 0) {
                    this.kyl_quantity_in_isEmpty = true;
                } else {
                    this.kyl_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.kyl.quantity_in;
            },
            set (){}
          },
          giant_cage_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.giant_cage.quantity_in == 0) {
                    this.giant_cage_quantity_in_isEmpty = true;
                } else {
                    this.giant_cage_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.giant_cage.quantity_in;
            },
            set (){}
          },
          disposable_pallet_quantity_in: {
            get(){
                if (this.$store.state.activeCustomer.disposable_pallet.quantity_in == 0) {
                    this.disposable_pallet_quantity_in_isEmpty = true;
                } else {
                    this.disposable_pallet_quantity_in_isEmpty = false;
                }
              return this.$store.state.activeCustomer.disposable_pallet.quantity_in;
            },
            set (){}
          },
          rolling_pallet_quantity_out: {
              get(){
                  if (this.$store.state.activeCustomer.rolling_pallet.quantity_out == 0) {
                      this.rolling_pallet_quantity_out_isEmpty = true;
                  } else {
                      this.rolling_pallet_quantity_out_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.rolling_pallet.quantity_out;
              },
              set (){}
          },
          pallet_quantity_out: {
              get(){
                  if (this.$store.state.activeCustomer.pallet.quantity_out == 0) {
                      this.pallet_quantity_out_isEmpty = true;
                  } else {
                      this.pallet_quantity_out_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.pallet.quantity_out;
              },
              set (){}
          },
          pallet_half_quantity_out: {
              get(){
                  if (this.$store.state.activeCustomer.pallet_half.quantity_out == 0) {
                      this.pallet_half_quantity_out_isEmpty = true;
                  } else {
                      this.pallet_half_quantity_out_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.pallet_half.quantity_out;
              },
              set (){}
          },
          veg_crate_quantity_out: {
              get(){
                  if (this.$store.state.activeCustomer.veg_crate.quantity_out == 0) {
                      this.veg_crate_quantity_out_isEmpty = true;
                  } else {
                      this.veg_crate_quantity_out_isEmpty = false;
                  }
                  return this.$store.state.activeCustomer.veg_crate.quantity_out;
              },
              set (){}
          },
          rolling_pallet_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.rolling_pallet == 0) {
                    this.rolling_pallet_quantity_returned_isEmpty = true;
                } else {
                    this.rolling_pallet_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.rolling_pallet;
            },
            set (){}
          },
          pallet_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.pallet == 0) {
                    this.pallet_quantity_returned_isEmpty = true;
                } else {
                    this.pallet_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.pallet;
            },
            set (){}
          },
          pallet_half_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.pallet_half == 0) {
                    this.pallet_half_quantity_returned_isEmpty = true;
                } else {
                    this.pallet_half_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.pallet_half;
            },
            set (){}
          },
          veg_crate_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.veg_crate == 0) {
                    this.veg_crate_quantity_returned_isEmpty = true;
                } else {
                    this.veg_crate_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.veg_crate;
            },
            set (){}
          },
          plastpall_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.plastpall == 0) {
                    this.plastpall_quantity_returned_isEmpty = true;
                } else {
                    this.plastpall_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.plastpall;
            },
            set (){}
          },
          plastpall_half_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.plastpall_half == 0) {
                    this.plastpall_half_quantity_returned_isEmpty = true;
                } else {
                    this.plastpall_half_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.plastpall_half;
            },
            set (){}
          },
          lokbin_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.lokbin == 0) {
                    this.lokbin_quantity_returned_isEmpty = true;
                } else {
                    this.lokbin_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.lokbin;
            },
            set (){}
          },
          kyl_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.kyl == 0) {
                    this.kyl_quantity_returned_isEmpty = true;
                } else {
                    this.kyl_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.kyl;
            },
            set (){}
          },
          giant_cage_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.giant_cage == 0) {
                    this.giant_cage_quantity_returned_isEmpty = true;
                } else {
                    this.giant_cage_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.giant_cage;
            },
            set (){}
          },
          disposable_pallet_quantity_returned: {
            get(){
                if (this.$store.state.currentDelivery.expected_pallets.disposable_pallet == 0) {
                    this.disposable_pallet_quantity_returned_isEmpty = true;
                } else {
                    this.disposable_pallet_quantity_returned_isEmpty = false;
                }
              return this.$store.state.currentDelivery.expected_pallets.disposable_pallet;
            },
            set (){}
          },
          plastpall_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.plastpall.quantity_out == 0) {
                    this.plastpall_quantity_out_isEmpty = true;
                } else {
                    this.plastpall_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.plastpall.quantity_out;
            },
            set (){}
          },
          plastpall_half_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.plastpall_half.quantity_out == 0) {
                    this.plastpall_half_quantity_out_isEmpty = true;
                } else {
                    this.plastpall_half_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.plastpall_half.quantity_out;
            },
            set (){}
          },
          lokbin_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.lokbin.quantity_out == 0) {
                    this.lokbin_quantity_out_isEmpty = true;
                } else {
                    this.lokbin_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.lokbin.quantity_out;
            },
            set (){}
          },
          kyl_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.kyl.quantity_out == 0) {
                    this.kyl_quantity_out_isEmpty = true;
                } else {
                    this.kyl_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.kyl.quantity_out;
            },
            set (){}
          },
          giant_cage_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.giant_cage.quantity_out == 0) {
                    this.giant_cage_quantity_out_isEmpty = true;
                } else {
                    this.giant_cage_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.giant_cage.quantity_out;
            },
            set (){}
          },
          disposable_pallet_quantity_out: {
            get(){
                if (this.$store.state.activeCustomer.disposable_pallet.quantity_out == 0) {
                    this.disposable_pallet_quantity_out_isEmpty = true;
                } else {
                    this.disposable_pallet_quantity_out_isEmpty = false;
                }
              return this.$store.state.activeCustomer.disposable_pallet.quantity_out;
            },
            set (){}
        },
        rolling_pallet_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.rolling_pallet.quantity_in == 0) {
                  this.rolling_pallet_quantity_isEmpty = true;
              } else {
                  this.rolling_pallet_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.rolling_pallet.quantity_in;
          },
          set (){}
        },
        pallet_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.pallet.quantity_in == 0) {
                  this.pallet_quantity_isEmpty = true;
              } else {
                  this.pallet_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.pallet.quantity_in;
          },
          set (){}
        },
        pallet_half_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.pallet_half.quantity_in == 0) {
                  this.pallet_half_quantity_isEmpty = true;
              } else {
                  this.pallet_half_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.pallet_half.quantity_in;
          },
          set (){}
        },
        veg_crate_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.veg_crate.quantity_in == 0) {
                  this.veg_crate_quantity_isEmpty = true;
              } else {
                  this.veg_crate_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.veg_crate.quantity_in;
          },
          set (){}
        },
        plastpall_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.plastpall.quantity_in == 0) {
                  this.plastpall_quantity_isEmpty = true;
              } else {
                  this.plastpall_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.plastpall.quantity_in;
          },
          set (){}
        },
        plastpall_half_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.plastpall_half.quantity_in == 0) {
                  this.plastpall_half_quantity_isEmpty = true;
              } else {
                  this.plastpall_half_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.plastpall_half.quantity_in;
          },
          set (){}
        },
        lokbin_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.lokbin.quantity_in == 0) {
                  this.lokbin_quantity_isEmpty = true;
              } else {
                  this.lokbin_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.lokbin.quantity_in;
          },
          set (){}
        },
        kyl_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.kyl.quantity_in == 0) {
                  this.kyl_quantity_isEmpty = true;
              } else {
                  this.kyl_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.kyl.quantity_in;
          },
          set (){}
        },
        giant_cage_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.giant_cage.quantity_in == 0) {
                  this.giant_cage_quantity_isEmpty = true;
              } else {
                  this.giant_cage_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.giant_cage.quantity_in;
          },
          set (){}
        },
        disposable_pallet_quantity: {
          get(){
              if (this.$store.state.currentDistributorPallets.pallets.disposable_pallet.quantity_in == 0) {
                  this.disposable_pallet_quantity_isEmpty = true;
              } else {
                  this.disposable_pallet_quantity_isEmpty = false;
              }
            return this.$store.state.currentDistributorPallets.pallets.disposable_pallet.quantity_in;
          },
          set (){}
        }
      }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Review.vue